const getGrantedStatus = (cart, product, collection, threshold) => {
  const hasProduct = cart.items.some((item) => item.product_id === +product);
  if (product && !hasProduct) {
    return false;
  }

  if (collection && collection === 'false') {
    return false;
  }

  if (threshold) {
    return cart.total_price >= threshold;
  }

  return true;
};

const initGift = async (evt) => {
  const { cart } = window.Rebuy.Cart;
  const node = document.getElementById('rebuy-cart');
  if (!node) return;

  const checkbox = node.querySelector<HTMLInputElement>('[data-gift-checkbox]');
  const label = node.querySelector<HTMLInputElement>('[data-cart-gift-element]');

  if (!checkbox || !label) {
    return;
  }

  const giftWrapVariantId = parseInt(node.dataset.giftProduct, 10);
  const threshold = parseInt(node.dataset.giftThreshold, 10);
  const conditionCollection = node.dataset.giftConditionCollection;
  const conditionProduct = node.dataset.giftConditionProduct;

  const hasVariant = cart.items.some((item) => item.variant_id === giftWrapVariantId);

  let isGranted = getGrantedStatus(cart, conditionProduct, conditionCollection, threshold);
  const isOnlyProduct = hasVariant && cart.item_count === 1;

  label.hidden = !isGranted;

  function checkboxChangeListener() {
    isGranted = getGrantedStatus(cart, conditionProduct, conditionCollection, threshold);
    if (isGranted) {
      if (checkbox.checked) {
        window.Rebuy.Cart.addItem({
          items: [
            {
              id: giftWrapVariantId,
              quantity: 1,
            },
          ],
        });
      } else {
        window.Rebuy.Cart.changeItem({
          id: giftWrapVariantId,
          quantity: 0,
        });
      }
    }
  }

  if (cart.item_count === 0) {
    if ((!isGranted && hasVariant) || isOnlyProduct) {
      window.Rebuy.Cart.changeItem({
        id: giftWrapVariantId,
        quantity: 0,
      });
    }
  }

  if (evt.type === 'rebuy:smartcart.ready') {
    checkbox.addEventListener('change', checkboxChangeListener);
  }
};

export default initGift;
